import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import ToggleButton from "shared/components/inputs/toggle-button/ToggleButton";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const StyledList = styled(VStack)`
    padding: 8px 24px;
    width: 621px;
    min-height: 436px;
    background: ${COLOR_VALUES.White};
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
`;

export const ListWrapper = styled(HStack)`
    padding: 16px 0;
    gap: 10px;
    label {
        align-items: inherit;
    }
`;

export const ChildListWrapper = styled(VStack)`
    padding: 0 0 0 32px;
`;

export const ListContent = styled(VStack)`
    padding: 0;
    gap: 16px;
    flex-grow: 1;
    align-items: start;
`;

export const StyledToggleButton = styled(ToggleButton)`
    gap: 48px;
    font-size: revert;
`;

export const StyledDivider = styled.div`
    border: 1px solid ${COLOR_VALUES.Gray_6};
`;
